import { Card, CardContent, Progress } from "alm-react-components";
import { useTranslation } from "react-i18next";
import { constants } from "../../../assets/constants/constants";

const MyProgress = ({
  progressBarData,
  progressBarCount,
  name,
  finishedWeekData,
}: {
  progressBarData: any;
  progressBarCount: any;
  name: string;
  finishedWeekData: () => void;
}) => {
  const finishedWeekLength: any = finishedWeekData();
  const res = finishedWeekLength?.filter((item: any) => {
    return item?.attributes?.state === constants.COMPLETED;
  });

  const { t } = useTranslation();
  return (
    <>
      <div className="w-[100%] mx-auto py-6 md:py-14 xl:px-32 lg:px-8 md:px-8 px-5">
        <div className="lg:flex lg:items-center lg:justify-between mb-4 md:mb-0">
          <div className="min-w-0 flex-1  md:pb-10">
            <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl md:text-4xl font-barlowLight font-light">
              <span
                dangerouslySetInnerHTML={{
                  __html: `${t("MyStance.myProgress")} ${name}`,
                }}
              />
            </h1>
          </div>
        </div>
        <Card className="dark:card-gradient-gray dark:text-white dark:border-cardBorder rounded-2xl">
          <CardContent className="grid gap-4 md:py-10 md:px-8 md:pb-7">
            <div className="md:grid lg:grid-cols-3 gap-6 xl:gap-6 md:pb-14">
              <div className="min-w-0 me-4 md:grid lg:grid-cols-2 gap-6 xl:gap-6">
                <div className="inline-flex items-center mt-3 pr-4">
                  <span className="font-barlowLight lg:text-5xl md:text-2xl font-light">
                    {progressBarData?.documents}
                  </span>
                  <span
                    className="ps-4 text-base font-sans font-light opacity-50"
                    dangerouslySetInnerHTML={{
                      __html: t("MyStance.documents"),
                    }}
                  />
                </div>
                <div className="inline-flex items-center mt-3 pr-4">
                  <span className="font-barlowLight lg:text-5xl md:text-2xl font-light">
                    {progressBarData?.videos}
                  </span>
                  <span
                    className="ps-4 text-base font-sans font-light opacity-50"
                    dangerouslySetInnerHTML={{ __html: t("MyStance.videos") }}
                  />
                </div>
                <div className="inline-flex items-center mt-3 pr-4">
                  <span className="font-barlowLight lg:text-5xl md:text-2xl font-light">
                    {progressBarData?.exercise}
                  </span>
                  <span
                    className="ps-4 text-base font-sans font-light opacity-50"
                    dangerouslySetInnerHTML={{ __html: t("MyStance.exercise") }}
                  />
                </div>
              </div>
              <div className="lg:col-span-2 items-center content-center">
                <div className=" flex flex-col flex-wrap items-center">
                  <p className="text-muted-foreground text-base font-light w-full text-right">
                    {res?.length}/{progressBarCount}
                  </p>
                  <Progress
                    value={(res?.length * 100) / progressBarCount}
                    className="w-full h-[7px] bg-fillDarkGrayCard"
                  />
                  <p
                    className="pt-3 text-muted-foreground text-base w-full text-left"
                    dangerouslySetInnerHTML={{
                      __html: t("MyStance.weeksCompleted"),
                    }}
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default MyProgress;
